import request from '@/utils/request'
import edu_request from '@/utils/edu_request'
import pay_request from '@/utils/pay_request'
import shouye_request from '@/utils/shouye_request'

// 课程
export function specialtyLesson(params) {
  return request({
    url: '/edu/lesson/specialtyLesson',
    method: 'get',
    params: params
  })
}
// 首页推荐课程
// export function searchRecommend(params) {
//   return request({
//     url: '/search/lesson/getrecommend',
//     method: 'get',
//     params
//   })
// }
export function getLessonList(params) {
  return shouye_request({
    url: '/edu/lesson/getLessonList',
    method: 'get',
    params: params
  })
}
// 获取课程标签
export function getTagsList(params) {
  return shouye_request({
    url: '/edu/lesson/getTagsList',
    method: 'get',
    params: params
  })
}

// 首页轮播
// export function classLesson(params) {
//   return request({
//     url: '/edu/lesson/classLesson',
//     method: 'get',
//     params
//   })
// }
// 轮播图
export function promotion(params) {
  return edu_request({
    url: '/home/index/promotion',
    method: 'get',
    params
  })
}
// 金刚区
// export function topH5(params) {
//   return request({
//     url: '/top/top/topH5',
//     method: 'get',
//     params
//   })
// }
export function getMenuList(params) {
  return edu_request({
    url: '/zkb/index/getMenuList',
    method: 'get',
    params
  })
}
// 直播专区
export function getLiveList(params) {
  return edu_request({
    url: '/home/index/live',
    method: 'get',
    params
  })
}
// 学习--必修选修
export function myCourse(params) {
  return request({
    url: '/learnCenter/mylesson/getlistmyLesson',
    method: 'get',
    params: params
  })
}
// 课程详情/edu/lesson/lessondetail
// export function lessondetail(params) {
//   return request({
//     url: '/edu/lesson/newLessonDetail',
//     method: 'get',
//     params: params
//   })
// }
export function lessondetail(params) {
  return edu_request({
    url: '/lesson/lesson/getLesson',
    method: 'get',
    params: params
  })
}
// 课程评价 /edu/lesson/commentlist
export function commentlist(params) {
  return request({
    url: '/edu/lesson/commentlist',
    method: 'get',
    params: params
  })
}
// 收藏 edu/lesson/editCollect?lesson_id
export function collectLesson(params) {
  return edu_request({
    url: '/lesson/lesson/collectLesson',
    method: 'get',
    params: params
  })
}
// 小結 edu/play/play
export function play(params) {
  return request({
    url: '/edu/play/play',
    method: 'get',
    params: params
  })
}
// 记录播放时间 edu/lesson/statistic
export function statistic(params) {
  return request({
    url: '/edu/lesson/statistic',
    method: 'get',
    params: params
  })
}
// 章节问答查询 /edu/lesson/answerPart
export function answerPart(params) {
  return request({
    url: '/edu/lesson/answerPart',
    method: 'get',
    params: params
  })
}
// 发布问答edu/lesson/addAnswer
export function addAnswer(params) {
  return request({
    url: '/edu/lesson/addAnswer',
    method: 'get',
    params: params
  })
}
// edu / lesson / addReply 回复问答
export function addReply(params) {
  return request({
    url: '/edu/lesson/addReply',
    method: 'get',
    params: params
  })
}
// 加入学习
export function joinLearn(params) {
  return pay_request({
    url: 'pay/college/joinLearn',
    method: 'get',
    params: params
  })
}
// 加入学习 edu/lesson/addStudy
export function addStudy(params) {
  return request({
    url: '/edu/lesson/addStudy',
    method: 'get',
    params: params
  })
}
// 添加评价 /edu/lesson/addComment
export function addComment(params) {
  return request({
    url: '/edu/lesson/addComment',
    method: 'get',
    params: params
  })
}
// 获取相关分组
export function getUserLessonGroup(params) {
  return request({
    url: 'edu/lesson/getUserLessonGroup',
    method: 'get',
    params: params
  })
}

// 封装接口数据
export function getH5IndexDatas(params) {
  return request({
    url: '/index/index/getH5Index',
    method: 'GET',
    params
  })
}
// 直播列表
export function getzhibo(params) {
  return request({
    url: '/edu/lesson/getLiveList',
    method: 'GET',
    params
  })
}
